import type { LessonDto } from '../dto/lesson.dto'
import { formatLessonDuration, sortLessonsByOrder } from '@/utils/helpers'
import type { CurriculumSection, CurriculumSectionItem } from '@/domain/entities/curriculum.entity'

/**
 * Урок с отформатированной длительностью для отображения (программа курса).
 */
export interface LessonDisplayDto extends LessonDto {
  lessonDurationFormatted: string
}

/**
 * Маппинг LessonDto в LessonDisplayDto с добавлением поля lessonDurationFormatted.
 */
export function mapLessonDtoToDisplay(dto: LessonDto): LessonDisplayDto {
  return {
    ...dto,
    lessonDurationFormatted: formatLessonDuration(dto.lesson_minutes),
  }
}

/**
 * Маппинг массива уроков с добавлением отформатированной длительности.
 */
export function mapLessonDtoArrayToDisplay(dtos: LessonDto[]): LessonDisplayDto[] {
  return dtos.map(mapLessonDtoToDisplay)
}

/**
 * Маппинг списка уроков в секции программы: каждый урок — отдельная секция (сортировка по lesson_order).
 */
export function mapLessonsToCurriculumSections(
  lessons: LessonDisplayDto[],
  defaultSectionTitle: string,
): CurriculumSection[] {
  if (!lessons.length) return []

  const sorted = sortLessonsByOrder(lessons)
  return sorted.map((l, index): CurriculumSection => ({
    title: index + 1 + '. ' + (l.lesson_title ?? defaultSectionTitle),
    expanded: false,
    sections: [
      {
        title: l.lesson_title ?? '',
        summary: l.lesson_summary ?? '',
        objectives: l.lesson_objectives ?? [],
        duration: l.lessonDurationFormatted ?? '',
      } as CurriculumSectionItem,
    ],
  }))
}
